import React from "react";
import Slider from "react-slick";

const KeySection = () => {
  const settingskey = {
 autoplay: true,
  speed: 3000,
  infinite: true,
  arrows: false,
  dots: true,
  pauseOnHover: false,
  slidesToShow: 1, 
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 768, 
      settings: {
        slidesToShow: 1,
      },
    },

    {
      breakpoint: 99999, 
      settings: "unslick", 
    },
  ],
};

  const slides = [
    {
      img: "/assets/images/education-img.webp",
      alt: "Education",
      title: "Green Supply Chain Practices",
      text: `Adopting eco-friendly practices across logistics operations, including route optimization, energy-efficient transport, and reduced fuel consumption. This helps lower carbon footprints and makes supply chains more sustainable.`,
    },
    {
      img: "/assets/images/hunger-img.webp",
      alt: "Hunger and Poverty",
      title: "Cold Chain Sustainability",
      text: `Investing in advanced cold storage refrigeration and energy-efficient cold storage warehouses to minimize energy usage and reduce wastage of perishable goods, while ensuring safe and sustainable handling.`,
    },
    {
      img: "/assets/images/env-img.webp",
      alt: "Sustainable Environment",
      title: "Waste Reduction & Circular Economy",
      text: `Encouraging packaging innovations, recycling initiatives, and waste reduction measures across warehouses and logistics hubs, promoting a circular economy that conserves resources and minimizes environmental impact.`,
    },
  ];

  return (
    <section className="key-section space">
      <div className="container">
        {/* Heading */}
        <div className="row justify-content-center">
          <div className="col-md-12 col-lg-8">
            <div className="heading-text">
              <h4 className="heading center-heading">Key Areas of Focus</h4>
            </div>
          </div>
        </div>

        {/* Key Slides */}
        <Slider {...settingskey} className="key-slides">
          {slides.map((item, index) => (
            <div key={index}  className="col-md-12 col-lg-4">
              <div className="key-sections">
                <div className="image">
                  <img
                    src={item.img}
                    className="img-responsive"
                    alt={item.alt}
                    loading="lazy"
                  />
                </div>
                <div className="keyc-content">
                  <div className="title">{item.title}</div>
                  <p>{item.text}</p>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default KeySection;
